import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-e-bill-details-table',
  templateUrl: './e-bill-details-table.component.html',
  styleUrl: './e-bill-details-table.component.scss'
})
export class EBillDetailsTableComponent {

  @Input() dataSource:any[] = []
}
